import { useState } from "react";
import { Check, MessageSquarePlus } from "lucide-react";

export const TaskItem = ({ index, item, onChange, disabled }) => {
  const [showNote, setShowNote] = useState(!!item.note);
  return (
    <div className={`px-4 sm:px-5 py-3.5 transition-colors duration-200 ${item.done ? "bg-[#DCFCE7]/40" : "bg-white"}`} data-testid={`task-item-${index}`}>
      <div className="flex items-start gap-3">
        <button
          type="button"
          disabled={disabled}
          data-testid={`task-checkbox-${index}`}
          onClick={() => onChange({ ...item, done: !item.done })}
          className={`mt-0.5 shrink-0 w-6 h-6 rounded-md border-2 flex items-center justify-center transition-colors duration-200 ${
            item.done ? "bg-[#15803D] border-[#15803D] text-white" : "border-[#C9BFB2] hover:border-[#C87D55]"
          }`}
        >
          {item.done && <Check className="w-4 h-4" strokeWidth={3} />}
        </button>
        <span className="text-xs text-[#9A9188] mt-1 w-5 shrink-0">{index + 1}</span>
        <p className={`flex-1 text-sm sm:text-base leading-relaxed ${item.done ? "text-[#666059]" : "text-[#1C201D]"}`}>{item.task}</p>
        {!disabled && (
          <button type="button" data-testid={`task-note-toggle-${index}`} onClick={() => setShowNote(!showNote)} className="p-1.5 rounded-md text-[#9A9188] hover:text-[#C87D55] hover:bg-[#F4F0EA]" title="Add note">
            <MessageSquarePlus className="w-4 h-4" />
          </button>
        )}
      </div>
      {(showNote || (disabled && item.note)) && (
        <input
          data-testid={`task-note-input-${index}`}
          disabled={disabled}
          value={item.note}
          onChange={(e) => onChange({ ...item, note: e.target.value })}
          placeholder="Result / note..."
          className="mt-2 ml-14 w-[calc(100%-3.5rem)] text-sm bg-[#FBF9F5] border border-[#E2DAD0] rounded-lg px-3 py-2 focus:outline-none focus:border-[#C87D55]"
        />
      )}
    </div>
  );
};
